import script from "./DeviceDetect.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceDetect.vue?vue&type=script&setup=true&lang=js"

import "./DeviceDetect.vue?vue&type=style&index=0&id=8e37bf8a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e37bf8a"]])

export default __exports__